export var SnapshotStatus;
(function (SnapshotStatus) {
    SnapshotStatus["Pending"] = "PENDING";
    SnapshotStatus["WaitingForBackup"] = "WAITING_FOR_BACKUP";
    SnapshotStatus["BackupSnapshotInProgress"] = "BACKUP_SNAPSHOT_IN_PROGRESS";
    SnapshotStatus["InvalidForBackup"] = "INVALID_FOR_BACKUP";
    SnapshotStatus["Provisioned"] = "PROVISIONED";
    SnapshotStatus["Completed"] = "COMPLETED";
    SnapshotStatus["PartialCompleted"] = "PARTIAL_COMPLETED";
    SnapshotStatus["Failed"] = "FAILED";
    SnapshotStatus["PendingDeletion"] = "PENDING_DELETION";
    SnapshotStatus["FailedPendingDeletion"] = "FAILED_PENDING_DELETION";
    SnapshotStatus["SnapshotStatusUnspecified"] = "SNAPSHOT_STATUS_UNSPECIFIED";
})(SnapshotStatus || (SnapshotStatus = {}));
